import React from "react";
import { Box, Button } from "@mui/material";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import { makeStyles } from "@mui/styles";
import heroImage from "../image/project_42_home.webp";
import heroVideo from "../../Logo/Homely_front_hero.mp4";

const useStyles = makeStyles((theme) => ({
  videoContainer: {
    position: "relative",
    height: "100vh",
    "@supports (height: 100svh)": {
      height: "100svh",
    },
    overflow: "hidden",
    backgroundColor: "#292720",
  },
  video: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
  },
  overlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(90deg, rgba(20, 19, 16, 0.73) 0%, rgba(20, 19, 16, 0.35) 48%, rgba(20, 19, 16, 0.08) 100%), linear-gradient(0deg, rgba(20, 19, 16, 0.2), transparent 45%)",
  },
  textOverlay: {
    position: "absolute",
    top: "50%",
    left: "max(7vw, 28px)",
    transform: "translateY(-43%)",
    color: "white",
    maxWidth: "660px",
    paddingRight: "24px",
    [theme.breakpoints.down("sm")]: {
      left: "24px",
      right: "20px",
      maxWidth: "none",
      paddingRight: 0,
    },
  },
  actions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "14px",
    marginTop: "34px",
  },
  getStartedButton: {
    color: "white",
    borderColor: "rgba(255, 255, 255, 0.75)",
    borderRadius: 0,
    padding: "12px 22px",
    fontSize: "0.72rem",
    fontWeight: 600,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    "&:hover": {
      borderColor: "white",
      backgroundColor: "rgba(255, 255, 255, 0.12)",
    },
  },
}));

const VideoWithTextOverlay = ({ onEnquire }) => {
  const classes = useStyles();

  return (
    <Box className={classes.videoContainer}>
      <Box
        component="video"
        className={classes.video}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        poster={heroImage}
        aria-label="Homely construction and home showcase"
      >
        <source src={heroVideo} type="video/mp4" />
      </Box>
      <Box className={classes.overlay} />
      <Box className={classes.textOverlay}>
        <Box className={classes.actions}>
          <Button
            variant="outlined"
            className={classes.getStartedButton}
            onClick={() => {
              const element = document.getElementById("our-promise");
              if (element) element.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Explore our properties
          </Button>
          <Button
            variant="text"
            startIcon={<EditNoteOutlinedIcon />}
            onClick={onEnquire}
            sx={{
              color: "white",
              px: 1.5,
              py: 1.5,
              borderRadius: 0,
              fontSize: "0.72rem",
              fontWeight: 600,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              "& .MuiButton-startIcon": { mr: 1 },
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.12)",
                color: "white",
              },
            }}
          >
            Enquire
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default VideoWithTextOverlay;
